import { z } from "zod/v4";

import { BaseNodeDefinitionSchema } from "./base-node";

export const StartNodeDefinitionSchema = BaseNodeDefinitionSchema.extend({
  type: z.literal("start"),
  config: z.any(),
});

export type StartNodeDefinition = z.infer<typeof StartNodeDefinitionSchema>;
